import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const labelMap: Record<string, string> = {
  national: 'National',
  state: 'Gujarat',
  discom: 'PGVCL',
  consumer: 'GJ-0482',
  vendor: 'Zebron Solar',
  overview: 'Overview',
  generation: 'Generation',
  states: 'States & DISCOMs',
  alarms: 'Alarms',
  compliance: 'Compliance',
  districts: 'Districts',
  'grid-ops': 'Grid Operations',
  'net-metering': 'Net Metering',
  circles: 'Circles',
  'remote-control': 'Remote Control',
  dashboard: 'Dashboard',
  electrical: 'Electrical',
  billing: 'Billing & Savings',
  support: 'Support',
  portfolio: 'Portfolio',
  plants: 'Plant List',
  tickets: 'Tickets',
  devices: 'Device Health',
};

export default function Breadcrumb() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length === 0) return null;

  return (
    <nav className="flex items-center gap-1 text-xs text-text-secondary px-4 py-2 border-b border-border bg-bg-secondary">
      {segments.map((seg, i) => {
        const path = '/' + segments.slice(0, i + 1).join('/');
        const isLast = i === segments.length - 1;
        const label = labelMap[seg] ?? seg;

        return (
          <React.Fragment key={seg}>
            {i > 0 && <ChevronRight size={11} className="text-text-tertiary flex-shrink-0" />}
            {isLast ? (
              <span className="font-medium text-text-primary">{label}</span>
            ) : (
              <Link to={path} className="hover:text-accent transition-colors">{label}</Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
